import { type CollabLayoutType } from '@databases/model/views/view';

import { type SystemTemplateType } from './types';

export type TemplateStorageData = {
  templateType?: SystemTemplateType;
  templateLayout?: CollabLayoutType;
  contentId?: string;
};

export type StorageType = {
  exists: (contentId: string) => boolean;
  getTemplateData: () => TemplateStorageData | undefined;
  remove: () => void;
};

const LS_TEMPLATE_KEY = 'databases-create-with-template-type';

export const storage: StorageType = {
  exists: (contentId: string) => {
    const data = storage.getTemplateData();
    return data?.contentId === contentId;
  },
  getTemplateData: () => {
    const item = localStorage.getItem(LS_TEMPLATE_KEY);
    if (!item) {
      return undefined;
    }
    try {
      return JSON.parse(item) as TemplateStorageData;
    } catch {
      return undefined;
    }
  },
  remove: () => {
    localStorage.removeItem(LS_TEMPLATE_KEY);
  }
};
